import type { ScormPackageInput } from '../types';

function escapeHtml(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

function buildPlayerUrl(input: ScormPackageInput): string {
  const url = new URL(input.playerLaunchUrl);
  url.searchParams.set('scorm', '1');
  if (!input.options.allowSeek) {
    url.searchParams.set('disableSeek', '1');
  }
  if (input.options.completionThreshold < 1) {
    url.searchParams.set('scormThreshold', String(input.options.completionThreshold));
  }
  if (input.options.pauseOnBlur) {
    url.searchParams.set('pauseOnBlur', '1');
  }
  return url.toString();
}

export function buildEntryHtml(input: ScormPackageInput): string {
  const url = escapeHtml(buildPlayerUrl(input));
  const title = escapeHtml(input.experience.title);

  return `<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <title>${title}</title>
  <style>
    html, body { margin: 0; padding: 0; height: 100%; background: #000; }
    iframe { border: 0; width: 100%; height: 100%; display: block; }
  </style>
  <script src="../shared/scorm-shim.js"></script>
</head>
<body>
  <iframe
    id="libertify-player"
    src="${url}"
    allow="autoplay; fullscreen; encrypted-media"
    allowfullscreen
    title="${title}"
  ></iframe>
</body>
</html>
`;
}
